import {LegacySamplesSource} from 'notebook/sample-propagation/legacy/legacy-add-samples-modal/LegacyAddSamplesModal';
import {Table} from 'notebook/tables/constants/TableConstants';

import getSampleDetailsFromNLADStructuredTable from '../getSampleDetailsFromNLADStructuredTable';

/**
 * This tool is used to gather the sample details for use in the AddSamples modal.
 * It looks for all the RunOutputSamplesTables (typically gathered by NoteEditorContainer),
 * and converts their cells into samples that can be moved to another setting (like a
 * transfer table).
 */

export default function getSampleDetailsFromNLADResultsTables(
  tables: Array<Table>
): Array<LegacySamplesSource> {
  return tables.map((t) => ({
    name: t.name,
    icon: 'table',
    sampleDetails: getSampleDetailsFromNLADStructuredTable(t),
  }));
}
